import app from './app';
import auth from './auth';

const reducers = {
  app,
  auth
};

export default reducers;
